var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataDepth = function SvgDataDepth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 66,
    fill: "none",
    viewBox: "0 0 62 66"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#data-depth_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.293 63.702a1 1 0 0 0 1.414 0l6.364-6.364a1 1 0 0 0-1.414-1.414L31 61.581l-5.657-5.657a1 1 0 0 0-1.414 1.414zM32 23.995a1 1 0 1 0-2 0zm-1 39h1v-39h-2v39z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 41.188,
    x: 0.406,
    y: 0.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#data-depth_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#data-depth_svg__c)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#data-depth_svg__d)",
    d: "M11 18c0-1.859 0-2.788.154-3.56a8 8 0 0 1 6.285-6.286C18.212 8 19.141 8 21 8h20c1.859 0 2.788 0 3.56.154a8 8 0 0 1 6.286 6.285C51 15.212 51 16.141 51 18s0 2.788-.154 3.56a8 8 0 0 1-6.285 6.286C43.788 28 42.859 28 41 28H21c-1.859 0-2.788 0-3.56-.154a8 8 0 0 1-6.286-6.285C11 20.788 11 19.859 11 18"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    d: "M21 8.5h20c1.882 0 2.75.003 3.463.145a7.5 7.5 0 0 1 5.892 5.892c.142.712.145 1.58.145 3.463 0 1.882-.003 2.75-.145 3.463a7.5 7.5 0 0 1-5.892 5.892c-.712.142-1.58.145-3.463.145H21c-1.882 0-2.75-.003-3.463-.145a7.5 7.5 0 0 1-5.892-5.892c-.142-.712-.145-1.58-.145-3.463 0-1.882.003-2.75.145-3.463a7.5 7.5 0 0 1 5.892-5.892C18.25 8.503 19.117 8.5 21 8.5Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 41.188,
    x: 0.406,
    y: 12.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#data-depth_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#data-depth_svg__f)",
    shapeRendering: "crispEdges"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#data-depth_svg__g)",
    fillOpacity: 0.5,
    d: "M11 30c0-1.859 0-2.788.154-3.56a8 8 0 0 1 6.285-6.286C18.212 20 19.141 20 21 20h20c1.859 0 2.788 0 3.56.154a8 8 0 0 1 6.286 6.285C51 27.212 51 28.141 51 30s0 2.788-.154 3.56a8 8 0 0 1-6.285 6.286C43.788 40 42.859 40 41 40H21c-1.859 0-2.788 0-3.56-.154a8 8 0 0 1-6.286-6.285C11 32.788 11 31.859 11 30"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#data-depth_svg__h)",
    fillOpacity: 0.25,
    d: "M11 30c0-1.859 0-2.788.154-3.56a8 8 0 0 1 6.285-6.286C18.212 20 19.141 20 21 20h20c1.859 0 2.788 0 3.56.154a8 8 0 0 1 6.286 6.285C51 27.212 51 28.141 51 30s0 2.788-.154 3.56a8 8 0 0 1-6.285 6.286C43.788 40 42.859 40 41 40H21c-1.859 0-2.788 0-3.56-.154a8 8 0 0 1-6.286-6.285C11 32.788 11 31.859 11 30",
    style: {
      mixBlendMode: "screen"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M21 20.5h20c1.882 0 2.75.003 3.463.145a7.5 7.5 0 0 1 5.892 5.892c.142.712.145 1.58.145 3.463 0 1.882-.003 2.75-.145 3.463a7.5 7.5 0 0 1-5.892 5.892c-.712.142-1.58.145-3.463.145H21c-1.882 0-2.75-.003-3.463-.145a7.5 7.5 0 0 1-5.892-5.892c-.142-.712-.145-1.58-.145-3.463 0-1.882.003-2.75.145-3.463a7.5 7.5 0 0 1 5.892-5.892c.712-.142 1.58-.145 3.463-.145Z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 41.188,
    x: 0.406,
    y: 24.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#data-depth_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#data-depth_svg__j)",
    shapeRendering: "crispEdges"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#data-depth_svg__k)",
    fillOpacity: 0.2,
    d: "M11 42c0-1.859 0-2.788.154-3.56a8 8 0 0 1 6.285-6.286C18.212 32 19.141 32 21 32h20c1.859 0 2.788 0 3.56.154a8 8 0 0 1 6.286 6.285C51 39.212 51 40.141 51 42s0 2.788-.154 3.56a8 8 0 0 1-6.285 6.286C43.788 52 42.859 52 41 52H21c-1.859 0-2.788 0-3.56-.154a8 8 0 0 1-6.286-6.285C11 44.788 11 43.859 11 42"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#data-depth_svg__l)",
    d: "M11 42c0-1.859 0-2.788.154-3.56a8 8 0 0 1 6.285-6.286C18.212 32 19.141 32 21 32h20c1.859 0 2.788 0 3.56.154a8 8 0 0 1 6.286 6.285C51 39.212 51 40.141 51 42s0 2.788-.154 3.56a8 8 0 0 1-6.285 6.286C43.788 52 42.859 52 41 52H21c-1.859 0-2.788 0-3.56-.154a8 8 0 0 1-6.286-6.285C11 44.788 11 43.859 11 42",
    style: {
      mixBlendMode: "screen"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M21 32.5h20c1.882 0 2.75.003 3.463.145a7.5 7.5 0 0 1 5.892 5.892c.142.712.145 1.58.145 3.463 0 1.882-.003 2.75-.145 3.463a7.5 7.5 0 0 1-5.892 5.892c-.712.142-1.58.145-3.463.145H21c-1.882 0-2.75-.003-3.463-.145a7.5 7.5 0 0 1-5.892-5.892c-.142-.712-.145-1.58-.145-3.463 0-1.882.003-2.75.145-3.463a7.5 7.5 0 0 1 5.892-5.892c.712-.142 1.58-.145 3.463-.145Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "data-depth_svg__a",
    width: 16.729,
    height: 43,
    x: 22.636,
    y: 22.995,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4772_7825"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4772_7825",
    result: "effect2_dropShadow_4772_7825"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4772_7825",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "data-depth_svg__c",
    width: 61.188,
    height: 41.188,
    x: 0.406,
    y: 0.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_7825"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_7825",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "data-depth_svg__f",
    width: 61.188,
    height: 41.188,
    x: 0.406,
    y: 12.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_7825"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_7825",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "data-depth_svg__j",
    width: 61.188,
    height: 41.188,
    x: 0.406,
    y: 24.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_7825"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_7825",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "data-depth_svg__d",
    x1: 32.25,
    x2: 32.25,
    y1: 8.294,
    y2: 41.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "data-depth_svg__g",
    x1: 31,
    x2: 31,
    y1: 28.875,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "data-depth_svg__k",
    x1: 31,
    x2: 31,
    y1: 40.875,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "data-depth_svg__b",
    transform: "translate(-.406 -.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 18c0-1.859 0-2.788.154-3.56a8 8 0 0 1 6.285-6.286C18.212 8 19.141 8 21 8h20c1.859 0 2.788 0 3.56.154a8 8 0 0 1 6.286 6.285C51 15.212 51 16.141 51 18s0 2.788-.154 3.56a8 8 0 0 1-6.285 6.286C43.788 28 42.859 28 41 28H21c-1.859 0-2.788 0-3.56-.154a8 8 0 0 1-6.286-6.285C11 20.788 11 19.859 11 18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "data-depth_svg__e",
    transform: "translate(-.406 -12.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 30c0-1.859 0-2.788.154-3.56a8 8 0 0 1 6.285-6.286C18.212 20 19.141 20 21 20h20c1.859 0 2.788 0 3.56.154a8 8 0 0 1 6.286 6.285C51 27.212 51 28.141 51 30s0 2.788-.154 3.56a8 8 0 0 1-6.285 6.286C43.788 40 42.859 40 41 40H21c-1.859 0-2.788 0-3.56-.154a8 8 0 0 1-6.286-6.285C11 32.788 11 31.859 11 30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "data-depth_svg__i",
    transform: "translate(-.406 -24.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 42c0-1.859 0-2.788.154-3.56a8 8 0 0 1 6.285-6.286C18.212 32 19.141 32 21 32h20c1.859 0 2.788 0 3.56.154a8 8 0 0 1 6.286 6.285C51 39.212 51 40.141 51 42s0 2.788-.154 3.56a8 8 0 0 1-6.285 6.286C43.788 52 42.859 52 41 52H21c-1.859 0-2.788 0-3.56-.154a8 8 0 0 1-6.286-6.285C11 44.788 11 43.859 11 42"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "data-depth_svg__h",
    width: 1.6,
    height: 3.2,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#data-depth_svg__m",
    transform: "scale(.00156 .00313)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "data-depth_svg__l",
    width: 1.6,
    height: 3.2,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#data-depth_svg__m",
    transform: "scale(.00156 .00313)"
  })))));
};
export default SvgDataDepth;